import { useParams } from 'react-router-dom'

import { ClassDocumentsFileViewerDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FileViewer as Viewer } from 'modules/trainings/components/Files/FileViewer'

export default function ClassDocumentsFileViewer() {
  const { id, classId, classFileId } = useParams()
  const { navigation } = useNavigation()

  // TODO: We're fetching trough the training class because there's an id mismatch
  // between the training class and the training class file at the entity level
  const { data, loading } = useQuery(ClassDocumentsFileViewerDocument, {
    variables: { id: String(classId) },
  })

  if (loading) return null

  const files =
    data?.trainings.trainingClass?.classFilesConnection.nodes.map((classFile) => ({
      id: classFile.id,
      filename: classFile.filename,
      title: classFile.title || classFile.filename,
      contentType: classFile.contentType,
      url: classFile.url,
      fileUrl: classFile.url,
      type: 'trainingClass' as const,
    })) || []

  const file = files?.find((f: { id: string }) => f.id === String(classFileId))

  if (!file) {
    throw new Error('File not found')
  }

  return (
    <Viewer
      file={file}
      files={files}
      urlBackTo={navigation.trainings.list.details_revamp.view.trainingClasses.detail.documents.fullPath(
        {
          id: String(id),
          classId: String(classId),
        }
      )}
      goNextFile={(f: { id: string }) =>
        navigation.trainings.list.details_revamp.view.trainingClasses.detail.documents.previewFile.fullPath(
          {
            id: String(id),
            classId: String(classId),
            classFileId: f.id,
          }
        )
      }
      goPrevFile={(f: { id: string }) =>
        navigation.trainings.list.details_revamp.view.trainingClasses.detail.documents.previewFile.fullPath(
          {
            id: String(id),
            classId: String(classId),
            classFileId: f.id,
          }
        )
      }
    />
  )
}
